<template>
  <el-dialog
    :title="`${$t('门禁清单')}`"
    :visible="visible"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    @close="closeDialog"
    class="small-dialog"
    v-dialogDrag
  >
    <div>
      <el-input
        clearable
        prefix-icon="el-icon-search"
        v-model="searchKey"
        :placeholder="$t('设备名称/设备编号')"
        size="small"
        class="w-180px mr-10px"
      ></el-input>
      <el-button size="small" @click="searchData" type="primary">{{ $t('搜索') }}</el-button>
      <el-button size="small" @click="rest" type="primary">{{ $t('重置') }}</el-button>
    </div>
    <div class="h-[calc(100%-90px)]">
      <el-table
        ref="tableRef"
        :data="tableData"
        v-loading="tableLoading"
        class="mt-10px"
        border
        stripe
        height="100%"
        row-key="code"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" reserve-selection  width="50"></el-table-column>
        <el-table-column type="index"  width="70" label="序号" align="center"></el-table-column>
        <el-table-column
          v-for="(it, index) in columnList"
          :key="index"
          :label="$t(it.label)"
          :prop="it.prop"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <el-pagination
        class="text-right mt-10px mb-10px p-0"
        background
        @size-change="getTableData"
        @current-change="getTableData"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        layout="total, sizes, prev, pager, next"
        :total="page.total"
        :pager-count="5"
      ></el-pagination>
    </div>
    <div slot="footer" class="text-center">
      <el-button type="primary" size="small" @click="onSubmit">{{ $t('保存') }}</el-button>
      <el-button size="small" @click="closeDialog">{{ $t('取消') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Tag3DPositionApi } from '@wiz-api/tag-3d-position-management'
// import { GraphConfigApi } from '@wiz-api/graph-analysis'
// import { IOTDeviceApi } from '@wiz-api/iot-device-management'
const tag3DPositionManagementAPI = new Tag3DPositionApi()
// const iotDeviceApi = new IOTDeviceApi()
// const graphConfigApi = new GraphConfigApi()
export default {
  name: 'SelectDoorList',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dataId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchKey: '',
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableLoading: false,
      tableData: [],
      columnList: [
        { label: '设备编码', prop: 'code' },
        // { label: '设备厂商', prop: 'manufacturerCode' },
        { label: '设备名称', prop: 'name' },
      ],
      selectionList: [],
    }
  },
  methods: {
    rest() {
      this.searchKey = ''
      this.searchData()
    },
    searchData() {
      this.page.pageNo = 1
      this.getTableData()
    },
    onSubmit() {
      if (!this.selectionList.length) {
        this.$message.error('请选择数据')
        return
      }
      const data = this.selectionList.map((it) => {
        // return {
        //   name: it.name,
        //   id: it.value,
        // }
        return it
      })
      this.$emit('success', data)
      this.closeDialog()
    },
    // 获取列表数据
    async getTableData() {
      this.tableLoading = true
      const [err, res] = await tag3DPositionManagementAPI.getTag3DPositionTagInfoList({
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        // sorting: 'startTime desc',
        tagTypeCode: 'IOTDeviceAccessControl',
        keyWord: this.searchKey ? this.searchKey : null,

      })
      if (!err) {
        this.tableData = res.items.map((it) => {
          return {
            ...it,
            id: it.tag3DPositionRelationKey,
          }
        })
        this.page.total = res.totalCount
        this.tableLoading = false
      }
    },
    closeDialog() {
      this.$emit('close')
    },
    handleSelectionChange(list) {
      // this.selectionList = []
      // if (list.length > 1) {
      //   this.$refs.tableRef.clearSelection()
      //   this.$refs.tableRef.toggleRowSelection(list[list.length - 1])
      // }
      // this.selectionList = list[list.length - 1] ? [list[list.length - 1]] : []
      this.selectionList = list
    },
  },
  created() {
    this.getTableData()
  },
}
</script>

<style lang='scss' scoped>
// ::v-deep .el-input--mini .el-input__icon {
//   line-height: 28px;
// }
</style>
